// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CtaBanner-eh-cta-section-JloD9 {
  width: 100%;
  background: #ffffff;
  padding: 32px 24px 72px;
}

.CtaBanner-eh-cta-section__container-JGixN {
  padding: 0px 60px 0px 60px;
  /* max-width: 1180px; */
  margin: 0 auto;
}

.CtaBanner-eh-cta-banner-zcalk {
  background: var(--primary-color);
  border-radius: 30px;
  padding: 24px 44px 44px 0px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 32px;
  -webkit-box-shadow: 0 16px 36px rgba(2, 132, 162, 0.22);
          box-shadow: 0 16px 36px rgba(2, 132, 162, 0.22);
  position: relative;
  overflow: visible;
}

.CtaBanner-eh-cta-banner__mascot-box-QxbrW {
  width: 220px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  margin-top: -16px;
  margin-bottom: -16px;

}

.CtaBanner-eh-cta-banner__mascot-img-pHeBY {
  position: absolute;
  width: 100%;
  height: 250px;
  top: -78px;
  margin-right: 110px;
  -o-object-fit: contain;
     object-fit: contain;
}

.CtaBanner-eh-cta-banner__content-E42OW {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 6px;
}

.CtaBanner-eh-cta-banner__title-lQcdx {
  font-size: 36px;
  font-weight: bold;
  color: #ffffff;
  margin: 0;
  font-family: var(--font-family-base);
}

.CtaBanner-eh-cta-banner__desc-PLi6x {
  font-size: 30px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-family: var(--font-family-base);
}

.CtaBanner-eh-cta-banner__action-pQwrv {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.CtaBanner-eh-cta-banner__btn-uzpcH {
  background: #ffffff;
  color: var(--primary-color);
  font-size: 32px;
  font-weight: bold;
  padding: 14px 28px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 25px;
  -webkit-transition: background 0.2s ease, -webkit-transform 0.2s ease, -webkit-box-shadow 0.2s ease;
  transition: background 0.2s ease, -webkit-transform 0.2s ease, -webkit-box-shadow 0.2s ease;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease, -webkit-transform 0.2s ease, -webkit-box-shadow 0.2s ease;
  white-space: nowrap;
}

.CtaBanner-eh-cta-banner__btn-uzpcH:hover {
  background: var(--primary-color);
  color: var(--white-color);
  -webkit-transform: scale(1.02);
      -ms-transform: scale(1.02);
          transform: scale(1.02);
  -webkit-box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.CtaBanner-eh-cta-banner__arrow-SWhoM {
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}

.CtaBanner-eh-cta-banner__btn-uzpcH:hover .CtaBanner-eh-cta-banner__arrow-SWhoM {
  -webkit-transform: translateX(3px);
      -ms-transform: translateX(3px);
          transform: translateX(3px);
}

@media (max-width: 900px) {
  .CtaBanner-eh-cta-banner-zcalk {
    grid-template-columns: 1fr;
    text-align: center;
    padding: 32px 24px;
    gap: 20px;
  }

  .CtaBanner-eh-cta-banner__mascot-box-QxbrW {
    margin: 0 auto;
    width: 80px;
    height: 80px;
  }

  .CtaBanner-eh-cta-banner__action-pQwrv {
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }

  .CtaBanner-eh-cta-banner__btn-uzpcH {
    width: 100%;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/WhyhostView/CtaBanner.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,oCAAoC;EACpC,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,uDAA+C;UAA/C,+CAA+C;EAC/C,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,oBAAc;MAAd,cAAc;EACd,iBAAiB;EACjB,oBAAoB;;AAEtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mGAA2E;EAA3E,2FAA2E;EAA3E,2EAA2E;EAA3E,sIAA2E;EAC3E,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,8BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,kDAA0C;UAA1C,0CAA0C;AAC5C;;AAEA;EACE,+CAA+B;EAA/B,uCAA+B;EAA/B,+BAA+B;EAA/B,4DAA+B;AACjC;;AAEA;EACE,kCAA0B;MAA1B,8BAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;AACF","sourcesContent":[".eh-cta-section {\n  width: 100%;\n  background: #ffffff;\n  padding: 32px 24px 72px;\n}\n\n.eh-cta-section__container {\n  padding: 0px 60px 0px 60px;\n  /* max-width: 1180px; */\n  margin: 0 auto;\n}\n\n.eh-cta-banner {\n  background: var(--primary-color);\n  border-radius: 30px;\n  padding: 24px 44px 44px 0px;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 32px;\n  box-shadow: 0 16px 36px rgba(2, 132, 162, 0.22);\n  position: relative;\n  overflow: visible;\n}\n\n.eh-cta-banner__mascot-box {\n  width: 220px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: -16px;\n  margin-bottom: -16px;\n\n}\n\n.eh-cta-banner__mascot-img {\n  position: absolute;\n  width: 100%;\n  height: 250px;\n  top: -78px;\n  margin-right: 110px;\n  object-fit: contain;\n}\n\n.eh-cta-banner__content {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.eh-cta-banner__title {\n  font-size: 36px;\n  font-weight: bold;\n  color: #ffffff;\n  margin: 0;\n  font-family: var(--font-family-base);\n}\n\n.eh-cta-banner__desc {\n  font-size: 30px;\n  color: rgba(255, 255, 255, 0.9);\n  margin: 0;\n  font-family: var(--font-family-base);\n}\n\n.eh-cta-banner__action {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.eh-cta-banner__btn {\n  background: #ffffff;\n  color: var(--primary-color);\n  font-size: 32px;\n  font-weight: bold;\n  padding: 14px 28px;\n  border-radius: 999px;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 25px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n  white-space: nowrap;\n}\n\n.eh-cta-banner__btn:hover {\n  background: var(--primary-color);\n  color: var(--white-color);\n  transform: scale(1.02);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n.eh-cta-banner__arrow {\n  transition: transform 0.2s ease;\n}\n\n.eh-cta-banner__btn:hover .eh-cta-banner__arrow {\n  transform: translateX(3px);\n}\n\n@media (max-width: 900px) {\n  .eh-cta-banner {\n    grid-template-columns: 1fr;\n    text-align: center;\n    padding: 32px 24px;\n    gap: 20px;\n  }\n\n  .eh-cta-banner__mascot-box {\n    margin: 0 auto;\n    width: 80px;\n    height: 80px;\n  }\n\n  .eh-cta-banner__action {\n    justify-content: center;\n  }\n\n  .eh-cta-banner__btn {\n    width: 100%;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eh-cta-section": `CtaBanner-eh-cta-section-JloD9`,
	"eh-cta-section__container": `CtaBanner-eh-cta-section__container-JGixN`,
	"eh-cta-banner": `CtaBanner-eh-cta-banner-zcalk`,
	"eh-cta-banner__mascot-box": `CtaBanner-eh-cta-banner__mascot-box-QxbrW`,
	"eh-cta-banner__mascot-img": `CtaBanner-eh-cta-banner__mascot-img-pHeBY`,
	"eh-cta-banner__content": `CtaBanner-eh-cta-banner__content-E42OW`,
	"eh-cta-banner__title": `CtaBanner-eh-cta-banner__title-lQcdx`,
	"eh-cta-banner__desc": `CtaBanner-eh-cta-banner__desc-PLi6x`,
	"eh-cta-banner__action": `CtaBanner-eh-cta-banner__action-pQwrv`,
	"eh-cta-banner__btn": `CtaBanner-eh-cta-banner__btn-uzpcH`,
	"eh-cta-banner__arrow": `CtaBanner-eh-cta-banner__arrow-SWhoM`
};
module.exports = ___CSS_LOADER_EXPORT___;
